import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-offers-mfe';
import { DebugService } from '../../shared/services/debug.service.js';
import { OffersService } from '../offers.service.js';
import { REFI_OFFERS_CONST } from '../../shared/constants/app.constants.js';
import { stratum } from '../../../constants/stratum.js';

export class RefiReviewOfferCard extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiReviewOfferCard');
    this.testingParam = new URL(window.location.href).searchParams.get('testing');

    this.debug.log('?testing=', this.testingParam, 'prodEnv:', !REFI_OFFERS_CONST.isProdEnv);
    if (this.testingParam && !REFI_OFFERS_CONST.isProdEnv) {
      this.debug.log('Testing review offer card');
      OffersService.isReviewOfferCardTesting = true;
    }
  }

  static properties = {
    hideSavingsPill: { type: Boolean, attribute: 'hide-savings-pill' },
  };

  connectedCallback() {
    super.connectedCallback();
    OffersService.getReviewOffer()
      .then(offerData => {
        if (!offerData.offerPayment || !offerData.offerApr || !offerData.term || !offerData.currentLoan.currentAPR || !offerData.currentLoan.currentTerm || !offerData.savings.lifetimeSavings || !offerData.savings.monthlySavings) {
          throw new Error('Failed to retrieve offer details for review');
        }
        this.offerPayment = offerData.offerPayment;
        this.offerApr = offerData.offerApr;
        this.offerTerm = offerData.term;
        this.currentApr = offerData.currentLoan.currentAPR;
        this.currentTerm = offerData.currentLoan.currentTerm;
        this.lifetimeSavings = offerData.savings.lifetimeSavings;
        this.monthlySavings = offerData.savings.monthlySavings;
        this.requestUpdate();
        stratum.publishTag(TagKey.CHECKOUT_PAGE_OFFER_CARD_LOAD, {
          replacements: {
            value: `successful - term:${this.offerTerm} apr:${this.offerApr} amt:${this.offerPayment}`,
          },
        });
        this.dispatchCompleteLoadingEvent();
      })
      .catch(err => {
        this.debug.error('Failed to retrieve offer details for review: ', err);
        stratum.publishTag(TagKey.CHECKOUT_PAGE_OFFER_CARD_LOAD, {
          replacements: {
            value: 'failed',
          },
        });
        this.dispatchFailedToLoadOrUpdateEvent();
      });
  }

  dispatchCompleteLoadingEvent() {
    this.dispatchEvent(
      new CustomEvent('checkout-completed-loading', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'offer-card',
        },
      }),
    );
    this.debug.log('completed loading event fired');
  }

  dispatchFailedToLoadOrUpdateEvent() {
    this.dispatchEvent(
      new CustomEvent('failed-load-or-update', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'offer-card',
        },
      }),
    );
    this.checkout = 'error';
    this.debug.log('failed to load or update event fired');
  }

  render() {
    return html`
      <div class="outer-div">
        <refi-review-offer-card-details
          monthly-payment="${this.offerPayment}"
          offer-apr="${this.offerApr}"
          offer-term="${this.offerTerm}"
          current-term="${this.currentTerm}"
          current-apr="${this.currentApr}"
          monthly-savings="${this.monthlySavings}"
          lifetime-savings="${this.lifetimeSavings}"
          ?hide-savings-pill="${this.hideSavingsPill}"
        ></refi-review-offer-card-details>
      </div>
    `;
  }
}

customElements.define('refi-review-offer-card', RefiReviewOfferCard);
